import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

const BetaTag = props => (
  <Stack direction='row' gap={0.25} marginLeft={0.5} alignItems='center'>
    <LocalOfferIcon color='success' sx={{fontSize: '1rem'}}/>
    <Typography color='success' variant='small'>Beta</Typography>
  </Stack>
);

export default BetaTag;